import { FC, SVGProps } from 'react'

export const Mattress: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M6.84697 6.93851C7.05635 6.59454 7.4299 6.38462 7.83258 6.38462H16.4564C16.8828 6.38462 17.2744 6.61973 17.4748 6.99603L19.902 11.5529H4.03808L6.84697 6.93851ZM3.38468 12.9376C3.38464 12.9417 3.38462 12.9459 3.38462 12.95V15.6411C3.38462 16.2784 3.90121 16.795 4.53846 16.795H19.3086C19.9458 16.795 20.4624 16.2784 20.4624 15.6411V12.9376H3.38468ZM7.83258 5C6.94668 5 6.12488 5.46184 5.66425 6.21856L2.37013 11.6301C2.12805 12.0278 2 12.4844 2 12.95V15.6411C2 17.0431 3.13651 18.1796 4.53846 18.1796H19.3086C20.7105 18.1796 21.8471 17.0431 21.8471 15.6411V12.8933C21.8471 12.4771 21.7447 12.0673 21.5491 11.7L18.6969 6.34512C18.256 5.51725 17.3944 5 16.4564 5H7.83258Z"
			fill="currentColor"
		/>
	</svg>
)
